'use client';

import { use } from 'react';

import { RibbonContext } from '@ravago/shared/page-elements-radiance/providers/ribbon-context-providers';
import { Ribbon as RadianceRibbon } from '@ravago/shared/radiance/components/ribbon/components/Ribbon/Ribbon';

const Ribbon = () => {
  const { state, dispatch } = use(RibbonContext);
  const ribbon = state.ribbon;

  if (!ribbon) return null;

  return (
    <RadianceRibbon variant={ribbon.variant} closable={ribbon.closable} onClose={() => dispatch({ type: 'hide_ribbon' })}>
      {ribbon.message}
    </RadianceRibbon>
  );
};

export default Ribbon;
